import React from 'react';
import { Field, SubmissionError, reduxForm } from 'redux-form';
import { Grid } from '@material-ui/core';
import { FormTextField } from '../../../../components/Form/index';
import {
  OfficePhoneLabel,
  StepControl,
  FormWrapper,
  StepperTitle,
  FieldWrapper,
  RolePicker
} from '../components';
import scrollToError from '../../../../utils/scrollToError';
import {
  validateEmail,
  required,
  minLength,
  maxLength,
  passwordRegExp
} from '../../../../utils/validators';
import {
  roles,
  ONBOARDING_STEPS,
  SIGNUP_ACH_METHODS,
  REGISTRATION_MAX_STRING_LENGTH
} from '../../../../constants';
import { user } from '../../../../utils/api';
import { setToken } from '../../../../utils/auth';




const validate = values => {
  const errors = {};

  if (values.password !== values.confirm_password) {
    errors.confirm_password = 'Password and confirm password must be same';
  }
  return errors;
};

const asyncValidate = values =>
  user
    .validateForm({
      email: values.email
    })
    .catch(({ response }) => {
      if (response.status === 400) {
        const errors = response.data.data.reduce(
          (acc, error) => ({
            ...acc,
            [error.field]: error.message
          }),
          {}
        );
        // eslint-disable-next-line no-throw-literal
        throw { ...errors };
      }
    });

const initialAccountCreation = onSubmit => values =>
  user
    .createUser({
      ...values,
      last_step:
        values.role === roles.BUYER
          ? ONBOARDING_STEPS.SECOND_BUYER_STEP
          : ONBOARDING_STEPS.SECOND_SELLER_STEP
    })
    .then(({ data }) => {
      onSubmit(values.role);
      setToken(data.data.token);
    })
    .catch(({ response }) => {
      if (response.status === 400) {
        const errors = (response.data.data || []).reduce(
          (acc, error) => ({
            ...acc,
            [error.field]: error.message
          }),
          {}
        );
        // eslint-disable-next-line no-throw-literal
        throw new SubmissionError(errors);
      }
    });

const maxStringLength = maxLength(REGISTRATION_MAX_STRING_LENGTH);

const firstStep = ({ handleSubmit, nextStep, role }) => (
  <form onSubmit={handleSubmit(initialAccountCreation(nextStep))}>
    <FormWrapper>
      <StepperTitle
        title="User Info"
        subTitle={`Step 1 of ${role === 'buyer' ? 5 : 3}`}
      />
      <Grid container spacing={24}>
        <FieldWrapper sm={6}>
          <Field
            name="first_name"
            component={FormTextField}
            label="First Name"
            fullWidth
            validate={[required, maxStringLength]}
          />
        </FieldWrapper>
        <FieldWrapper sm={6}>
          <Field
            name="last_name"
            component={FormTextField}
            label="Last Name"
            fullWidth
            validate={[required, maxStringLength]}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            name="email"
            component={FormTextField}
            type="email"
            label="Email"
            fullWidth
            validate={[required, validateEmail]}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            name="dealership_name"
            component={FormTextField}
            label="Dealer Name"
            fullWidth
            validate={[required, maxStringLength]}
          />
        </FieldWrapper>
        {/*        <FieldWrapper>
          <Field
            name="username"
            component={FormTextField}
            label="Create Username"
            fullWidth
            validate={[required, maxStringLength]}
          />
        </FieldWrapper> */}
        <FieldWrapper sm={6}>
          <Field
            name="password"
            type="password"
            component={FormTextField}
            label="Create Password"
            fullWidth
            validate={[required, minLength(8), maxLength(25), passwordRegExp]}
          />
        </FieldWrapper>
        <FieldWrapper sm={6}>
          <Field
            name="confirm_password"
            type="password"
            component={FormTextField}
            label="Password confirmation"
            fullWidth
            validate={required}
          />
        </FieldWrapper>
        <FieldWrapper>
          <RolePicker />
        </FieldWrapper>
      </Grid>
    </FormWrapper>
    <OfficePhoneLabel />
    <StepControl />
  </form>
);

export default reduxForm({
  form: 'registrationForm',
  destroyOnUnmount: false,
  fields: [
    'dealership_name',
    // 'username',
    'first_name',
    'last_name',
    'email',
    'password',
    'confirm_password',
    'role'
  ],
  initialValues: {
    role: 'buyer',
    buy_fee_method: 'credit_card',
    ach_method: SIGNUP_ACH_METHODS.ENTER_ACH_INFORMATION,
    documents_upload_method: 'upload',
    purchase_method: {
      ach: true,
      flooring: true,
      cash: true,
      company_check: true,
      cashiers_check: true
    }
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['email'],
  onSubmitFail: scrollToError
})(firstStep);
